import React from 'react';
import ReactGA from 'react-ga';
import aquaLogo from './images/AquaScape.svg';
import aquaSmall from './images/aqua-small-2.svg';
import longlineLogo from './images/Longline_logo_web.svg';
import sfpLogo from './images/SFP-Logo-Blue.svg';
import wffLogo from './images/Walton-Family-Foundation.png';
import './App.scss';
import Image from 'react-bootstrap/Image';
import Navbar from 'react-bootstrap/Navbar';
import NavLink from 'react-bootstrap/NavLink';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Map from './Map';
import SidebarLocations from './SidebarLocations';
import Loader from './Loader';
import layers from './constants/layers.json';
import { Pie, Bar, Doughnut } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import { Checkbox } from 'antd';
import 'antd/lib/checkbox/style/index.css';
import 'antd/lib/collapse/style/index.css';
import findIndex from 'lodash.findindex';
import find from 'lodash.find';
import set from 'lodash.set';
import { languageCodes, strings } from '../src/constants/localization';
import koeffPonds from './constants/ponds_coeff.json';

ReactGA.initialize('UA-146805815-1', {
  gaOptions: {
    siteSpeedSampleRate: 100
  }
});

const storageLanguageKey = 'language';

const pieSliceColors = ['#0e4368', '#3bade1', '#78b636', '#d73ff4', '#e07e00'];
const nitAndPhosChartData = {
  datasets: [{
    data: [],
    backgroundColor: pieSliceColors,
    borderWidth: 0,
  }],
  labels: []
};

const nitAndPhosChartOptions = {
  title: {
    display: true,
    text: '',
    fontColor: 'white',
  },
  legend: {
    display: true,
    position: 'left',
    labels: {
      fontColor: 'white',
      boxWidth: 15,
      fontSize: 10
    }
  },
  plugins: {
    datalabels: {
      display: true,
      color: '#white',
      anchor: 'center'
    }
  },
  responsive: true,
  maintainAspectRatio: false
};

const nitrogenBarChartOptions = {
  maintainAspectRatio: false,
  title: {
    display: true,
    text: '',
    fontColor: 'white'
  },
  legend: {
    display: false,
  },
  plugins: {
    datalabels: {
      display: true,
      color: 'white',
      anchor: 'end',
      align: 'end'
    }
  },
  scales: {
    yAxes: [{
      ticks: {
        fontColor: "rgba(255, 255, 255, 0.7)",
        stepsize: 1000,
        maxTicksLimit: 5
      }
    }],
    xAxes: [{
      ticks: {
        fontColor: "rgba(255, 255, 255, 0.7)",
        stepsize: 1000,
        maxRotation: 25
      }
    }]
  }
};

const totalPieChartOptions = {
  title: {
    display: true,
    text: '',
    fontSize: 16,
    fontFamily: "'Fira Sans', sans-serif",
    fontColor: 'white',
    lineHeight: 1.5,
    padding: 30
  },
  legend: {
    display: true,
    position: 'left',
    labels: {
      fontColor: 'white',
      boxWidth: 15,
      fontSize: 14
    }
  },
  plugins: {
    datalabels: {
      color: 'white',
      anchor: 'center',
      display: 'auto'
    }
  },
  responsive: true,
  maintainAspectRatio: false,
};

const totalBarChartOptions = {
  maintainAspectRatio: false,
  title: {
    display: true,
    text: '',
    fontColor: 'white',
    fontSize: 16,
    padding: 30
  },
  legend: {
    display: false,
  },
  plugins: {
    datalabels: {
      display: true,
      color: 'white',
      anchor: 'end',
      align: 'end'
    }
  },
  scales: {
    yAxes: [{
      ticks: {
        fontColor: "rgba(255, 255, 255, 0.7)",
        stepsize: 1000,
        maxTicksLimit: 5
      }
    }],
    xAxes: [{
      ticks: {
        fontColor: "rgba(255, 255, 255, 1)",
        stepsize: 1000,
        maxRotation: 25,
        fontSize: 14
      }
    }]
  }
};

const koeff = {
  volume: 1.5,
  stock: 195,
  production: 8.6242,
  ammonia: 0.3744,
  nitrogen: 0.00828,
  algae: 0.001064,
  income: 3.5,
  exter1: 3.3,
  exter2: 30,
  nExc: 0.519,
  nReg: 0.0754,
  nProd: 0.0246
}

const mapPositionDefault = {lat: -8.700, lng: 115.092, zoom: 9};

class App extends React.Component {
  constructor() {
    super();

    ReactGA.pageview(window.location.pathname);

    this.state = {
      languageLabel: languageCodes[strings.getLanguage()].label,
      mapPosition: mapPositionDefault, //layers[0].mapPosition,
      sidebarLayers: [ ...layers ],
      layers: [],
      loadingLayers: false,
      context: {type: null, lat: null, lng: null, info: {}},
      contextLocked: false,
      toolbars: {
        layers: {
          label: "Layers",
          isChecked: true
        },
        charts: {
          label: "Charts",
          isChecked: true
        }
      },
      koeffPonds: [ ...koeffPonds ],
      activeTotalStats: 'bali'
    };
  }

  componentDidMount() {
    const preferredLanguage = localStorage.getItem(storageLanguageKey);
    if (preferredLanguage) {
      this.setLanguage(preferredLanguage);
    }
  }

  setLanguage = (languageCode) => {
    strings.setLanguage(languageCode);
    localStorage.setItem(storageLanguageKey, languageCode);
    this.setState({ 
      ...this.state,
      languageLabel: languageCodes[strings.getLanguage()].label 
    });
  }

  onToolbarCheckChange = (toolbarKey) => {
    this.setState({
      ...this.state,
      toolbars: {...this.state.toolbars,
        [toolbarKey]: {...this.state.toolbars[toolbarKey],
          isChecked: !this.state.toolbars[toolbarKey].isChecked
        }
      }
    });
  }

  getContextClass = () => {
    if (this.state.toolbars.charts.isChecked) {
      return "context show";
    } else {
      return "context";
    }
  }

  getSidebarClass = () => {
    if (this.state.toolbars.layers.isChecked) {
      return "sidebar show"
    } else {
      return "sidebar"
    }
  }

  updateMapPosition = async (locationKey) => {
    const location = find(this.state.sidebarLayers, { 'key': locationKey });
    console.log(location)
    console.log(this.state.mapPosition)
    
    await this.setStateAsync({ 
      ...this.state, 
      mapPosition: mapPositionDefault
    });
    await this.sleep(300);
    if (location.mapPosition === this.state.mapPosition) {
      await this.setStateAsync({ 
        ...this.state, 
        mapPosition: { ...location.mapPosition, zoom: 10 }
      });
    } 
    else {
      this.setStateAsync({ 
        ...this.state, 
        mapPosition: location.mapPosition
      });
    }    
  }

  sidebarLayerState = (locationIndex, currentState, keyPath, checked) => {
    let newState = [ ...currentState ];
    const keys = keyPath.split('.');    
    let path = newState[locationIndex];
    let keyIndices = [locationIndex.toString()];
    let isHeading = true;
    keys.map(key => {
      const headingKey = find(path.headings, { 'key': key });
      if (headingKey) {
        let index = findIndex(path.headings, { 'key': key });
        keyIndices.push("headings");
        keyIndices.push(index.toString());
        path = headingKey;
      } else {
        let index = findIndex(path.layers, { 'key': key });
        keyIndices.push("layers");
        keyIndices.push(index.toString());
        path = find(path.layers, { 'key': key });
        isHeading = false;
      }
      return path;
    });

    if (isHeading) {
      path.headings.forEach(heading => {
        newState = this.sidebarLayerState(
          locationIndex,
          [ ...newState ],
          keyPath.concat(`.${heading.key}`),
          checked
        )
      });

      path.layers.forEach(layer => {
        newState = this.sidebarLayerState(
          locationIndex,
          [ ...newState ],
          keyPath.concat(`.${layer.key}`),
          checked
        )
      });
    }

    set(
      newState,
      keyIndices.concat(['isChecked']),
      checked
    );

    return newState;
  }

  onLayerCheckChange = async (e, locationKey, keyPath) => {
    const locationIndex = findIndex(this.state.sidebarLayers, { 'key': locationKey });
    const newSidebarState = this.sidebarLayerState(
      locationIndex,
      [ ...this.state.sidebarLayers ],
      keyPath,
      e.target.checked
    );

    await this.setStateAsync({ ...this.state, loadingLayers: true });
    await this.setStateAsync({ ...this.state, sidebarLayers: newSidebarState });
    await this.setStateAsync({ 
      ...this.state,
      layers: await this.state.sidebarLayers.reduce(this.getCheckedLayers, [])
    });
    await this.setStateAsync({ ...this.state, loadingLayers: false });
  }

  // TODO: pull this out into util
  setStateAsync = (state) => {
    return new Promise((resolve) => {
      this.setState(state, resolve)
    });
  }

  sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  getCheckedLayers = async (result, heading) => {
    result = await heading.headings.reduce(this.getCheckedLayers, result);
    const checkedLayers = await heading.layers
    .filter(layer => layer.isChecked)
    .map(async (layer) => {
      if (layer.data === null) {
        await fetch(layer.source)
        .then((res) => res.json())
        .then((data) => {
          layer.data = data
        });
      }
      return layer;
    });

    const loadedLayers = await Promise.all(checkedLayers)
    .then((result) => result);

    return result.concat(loadedLayers);
  }

  isLayerChecked = (layerKey) => {
    return findIndex(this.state.layers, (layer) => { return layer.key === layerKey }) > -1;
  }

  onContextChange = (context) => {
    if (!this.state.contextLocked) {
      this.setState({
        ...this.state,
        context: context
      });
    }
  }

  onLockContext = (context) => {
    if (this.state.contextLocked) {
      this.onUnlockContext();
    } else {
      this.setState({
        ...this.state,
        context: context,
        contextLocked: true
      });
    }
  }

  toggleActiveTotalStats(type) {
    if (this.state.activeTotalStats !== type) {
      this.setState({activeTotalStats: type})
    }
  }

  onUnlockContext = () => {
    this.setState({ 
      ...this.state,
      contextLocked: false 
    });
  }

  round2 = (n) => {
    return parseFloat(n) ? parseFloat(n).toFixed(2) : null
  }
 
  round0 = (n) => {
    return parseFloat(n) ? parseFloat(n).toFixed(0) : null
  }

  thousandsSeparator = (n) => {
    return parseFloat(n) ? parseFloat(n).toLocaleString().replace(/,/g," ",) : null
  }

  m2ToHa = (n) => {
    return parseFloat(n) ? parseFloat(n)/10000 : null
  }

  m2ToRai = (n) => {
    return parseFloat(n) ? (parseFloat(n)/10000)*16 : null
  }

  kgToTon = (n) => {
    return parseFloat(n) ? parseFloat(n)/1000 : null
  }
  

  render() {
    const languageOptions = Object.keys(languageCodes).map(languageCode => {
      return (
        <NavDropdown.Item key={languageCode} onClick={ () => this.setLanguage(languageCodes[languageCode].code) } href="# ">
          { languageCodes[languageCode].label }
        </NavDropdown.Item>
      );
    });

    const toolbarOptions = Object.keys(this.state.toolbars).map(toolbarKey => {
      return (
        <NavDropdown.Item key={toolbarKey} onClick={() => this.onToolbarCheckChange(toolbarKey)} href="# ">
          <Checkbox 
            checked={ this.state.toolbars[toolbarKey].isChecked }
            onChange={() => this.onToolbarCheckChange(toolbarKey)}>
            { this.state.toolbars[toolbarKey].label }
          </Checkbox>
        </NavDropdown.Item>
      );
    })

    let headerNav = () => {
      return (
        <Navbar fixed="top py-0" expand="md">
          <Navbar.Brand>
            <Image className="logo" src={aquaLogo} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav" className="justify-content-end">
            <NavDropdown title="Toolbars">
              { toolbarOptions }
            </NavDropdown>
            <NavLink href="https://www.longline.co.uk/flow/products/aquascape/" target="blank">AquaScape</NavLink>
            <NavLink href="https://www.longline.co.uk/flow/contacts/" target="blank">Contacts</NavLink>
            <NavDropdown title={ strings.language + ": " + this.state.languageLabel } id="basic-nav-dropdown">
              { languageOptions }
            </NavDropdown>
          </Navbar.Collapse>
        </Navbar>
      );
    }
    
    let nitrogenPieChart = (context) => {
      const nitrogenChartOptions = {
        ...nitAndPhosChartOptions,
        title: { ...nitAndPhosChartOptions.title, text: strings.nitrogenTitle }
      };

      const nitrogenChartData = {
        ...nitAndPhosChartData,
        labels: [
          strings.naturalAreas,
          strings.annualCrops,
          strings.permanentCrops,
          strings.wastewaterUrbanAreas
        ],
        datasets: Object.assign([...nitAndPhosChartData.datasets], {
          0: {
            ...nitAndPhosChartData.datasets[0],
            data: [
              this.round2(context.info.NTotTon_Na), 
              this.round2(context.info.NTotTon_An), 
              this.round2(context.info.NTotTon_Pe), 
              this.round2(context.info.NTotTon_WW)
            ]
          }
        })
      };

      return (
        <div className="chart">
          <Pie 
            data={ nitrogenChartData }
            options={ nitrogenChartOptions } />
        </div>
      )
    }

    let carryingCapacityNitrogenPieChart = (context) => {
      const nitrogenChartOptions = {
        ...nitAndPhosChartOptions,
        title: { ...nitAndPhosChartOptions.title, text: strings.nitrogenTitle }
      };

      const nitrogenChartData = {
        ...nitAndPhosChartData,
        labels: [
          strings.naturalAreas,
          strings.annualCrops,
          strings.permanentCrops,
          strings.wastewaterUrbanAreas,
          strings.shrimpPonds
        ],
        datasets: Object.assign([...nitAndPhosChartData.datasets], {
          0: {
            ...nitAndPhosChartData.datasets[0],
            data: [
              this.round2(context.info.NTotTon_Na), 
              this.round2(context.info.NTotTon_An), 
              this.round2(context.info.NTotTon_Pe), 
              this.round2(context.info.NTotTon_WW),
              this.round2(context.info.NTotTon_SL)
            ]
          }
        })
      };
      if (context.info.NTotTon_Na||context.info.NTotTon_An||context.info.NTotTon_Pe||context.info.NTotTon_WW||context.info.NTotTon_SL) {
        return (
          <div className="chart">
            <Pie 
              data={ nitrogenChartData }
              options={ nitrogenChartOptions } />
          </div>
        )
      }
    }

    let phosphorusPieChart = (context) => {
      const phosphorusChartOptions = {
        ...nitAndPhosChartOptions, 
        title: { ...nitAndPhosChartOptions.title, text: strings.phosphorusTitle }
      };

      const phosphorusChartData = {
        ...nitAndPhosChartData,
        labels: [
          strings.naturalAreas,
          strings.annualCrops,
          strings.permanentCrops,
          strings.wastewaterUrbanAreas
        ],
        datasets: Object.assign([...nitAndPhosChartData.datasets], {
          0: {
            ...nitAndPhosChartData.datasets[0],
            data: [
              this.round2(context.info.PTotTon_Na), 
              this.round2(context.info.PTotTon_An), 
              this.round2(context.info.PTotTon_Pe), 
              this.round2(context.info.PTotTon_WW)
            ]
          }
        })
      };

      return (
        <div className="chart">
          <Pie 
            data={ phosphorusChartData }
            options={ phosphorusChartOptions } />
        </div>
      )
    }

    let nitrogenBarChart = (context) => {
      const chartOptions = {
        ...nitrogenBarChartOptions,
        title: { ...nitrogenBarChartOptions.title, text: strings.nitrogenBarTitle }
      };
      const koeffs = this.state.koeffPonds.filter(item => item.Pond_type === context.info.Pond_Class)[0];
      if (koeffs && (Number(koeffs.nExc) || Number(koeffs.nReg) || Number(koeffs.nProd))) {
        const nitrogenChartData = {
          labels: [
            strings.excretion,
            strings.regeneration,
            strings.algae
          ],
          datasets: [
            {
              ...nitAndPhosChartData.datasets[0],
              data: [
                this.round2(context.info["Area (m2)"] * koeffs.nExc), 
                this.round2(context.info["Area (m2)"] * koeffs.nReg), 
                this.round2(context.info["Area (m2)"] * koeffs.nProd)
              ]
            }
          ]
        };
  
        return (
          <div className="chart">
            <Bar 
              data={ nitrogenChartData }
              options={ chartOptions } />
          </div>
        )
      }
      
    }

    let getTotals = (type, context) => {
      const koeffs = this.state.koeffPonds.filter(item => item.Pond_type === context.info.Pond_Class)[0];
      if (koeffs) {
        return this.thousandsSeparator(
          this.round0(
            context.info["Area (m2)"] * Number(koeffs[type])
          )
        )
      }
    }

    let areaHaDonut = (type) => {
      const chartOptions = {
        ...totalPieChartOptions,
        title: { ...totalPieChartOptions.title, text: strings.areaHa[type] },
        legend: { 
          ...totalPieChartOptions.legend,
          position: 'bottom'
        }
      };

      const dataset = {
        bali: [44921, 72549, 26027, 4634, 104],
        java: [175786, 231882, 185881, 32696, 787]
      }

      const chartData = {
        labels: [
          strings.naturalAreas,
          strings.annualCrops,
          strings.permanentCrops,
          strings.urbanAreas,
          strings.shrimpAquaculture
        ],
        datasets: [
          {
            ...nitAndPhosChartData.datasets[0],
            data: dataset[type]
          }
        ]
      };

      return (
        // <div className="chart">
          <Doughnut 
            data={ chartData }
            options={ chartOptions } />
        // </div>
      )
    }

    let totalNLoadsDonut = (type) => {
      const chartOptions = {
        ...totalPieChartOptions,
        title: { ...totalPieChartOptions.title, text: strings.totalNLoadsTonY[type] },
        legend: { 
          ...totalPieChartOptions.legend,
          position: 'bottom'
        }
      };

      const dataset = {
        bali: [386, 2186, 307, 2636, 621],
        java: [1445, 3348, 5914, 3567, 2012]
      }

      const chartData = {
        labels: [
          strings.naturalAreas,
          strings.annualCrops,
          strings.permanentCrops,
          strings.urbanAreas,
          strings.shrimpAquaculture
        ],
        datasets: [
          {
            ...nitAndPhosChartData.datasets[0],
            data: dataset[type]
          }
        ]
      };

      return (
        // <div className="chart">
          <Doughnut 
            data={ chartData }
            options={ chartOptions } />
        // </div>
      )
    }

    let externalitiesBarChart = (type) => {
      const chartOptions = {
        ...totalBarChartOptions,
        title: { ...totalBarChartOptions.title, text: strings.externalitiesKUsdY[type] }
      };

      const dataset = {
        bali: [-19871, -2792, -23966, -5643],
        java: []
      }

      const chartData = {
        labels: [
          strings.annualCrops,
          strings.permanentCrops,
          strings.urbanAreas,
          strings.shrimpAquaculture
        ],
        datasets: [
          {
            ...nitAndPhosChartData.datasets[0],
            data: dataset[type],
            backgroundColor: ['#3bade1', '#78b636', '#d73ff4', '#e07e00'],
            borderWidth: 0
          }
        ]
      };

      return (
        // <div className="chart">
          <Bar 
            data={ chartData }
            options={ chartOptions } />
        // </div>
      )
    }

    let totalShrimpAquaculture = (type, datasetType) => {
      const chartOptions = {
        ...totalPieChartOptions,
        title: { ...totalPieChartOptions.title, text: strings[datasetType][type] },
        legend: { 
          ...totalPieChartOptions.legend,
          position: 'bottom'
        },
        cutoutPercentage: 0,
      };

      const dataset = {
        shrimpAquacultureByType: {
          java: [530, 41, 1063, 20]
        },
        shrimpAquacultureAreaHa: {
          java: [211, 13, 485, 78]
        },
        shrimpAquacultureTotalNLoads: {
          java: [48, 5, 1494, 466]
        },
        shrimpAquacultureProduction: {
          java: [726, 83, 18630, 6751]
        },
      }

      const chartData = {
        labels: [
          strings.extensive,
          strings.semi,
          strings.intensive,
          strings.superIntensive
        ],
        datasets: [
          {
            ...nitAndPhosChartData.datasets[0],
            data: dataset[datasetType][type],
            backgroundColor: ['#3bade1', '#78b636', '#fca44b', '#ea67ad'],// <-different['#fff1bd', '#f1bd00', '#e69f44', '#e4704d'], //['#aae3f5', '#adcded', '#7aa3e5', '#a27ea8'],// ['#c0d4e8', '#99c4da', '#68a9cf', '#2f7eb7'], ////['#ceeaf6', '#85cae7', '#33a7d8', '#0092ce'], // <-blue ['#c4c4c4', '#d67520', '#b1312e', '#5b1a2d'], // <-dark red ['#eca631', '#e56d72', '#ba65a3', '#59609d'], // <-pastele ['#faa2c1', '#f06595', '#d6336c', '#a61d4d'], // <-dark pink ['#fad9ea', '#f1a3cd', '#e966ac', '#e44097'], // <-pink ['#78b636', '#3bade1', '#0e4368', '#e07e00'], // <-standard ['#e07e00', '#e0ab67', '#dec6a7', '#bf6c00'],
            borderWidth: 2,
            borderColor: '#1f2b2e'
          }
        ]
      };

      return (
        // <div className="chart">
          <Doughnut 
            data={ chartData }
            options={ chartOptions } />
        // </div>
      )
    }

    let carryingCapacityBarChart = (context) => {
      const chartOptions = {
        ...nitrogenBarChartOptions
      };

      const chartData = {
        labels: [
          strings.ammonia,
          strings.din,
          strings.phytoplanktonBiomass,
          strings.zooplanktonBiomass
        ],
        datasets: Object.assign([...nitAndPhosChartData.datasets], {
          0: {
            ...nitAndPhosChartData.datasets[0],
            data: [
              this.round2(context.info["NH3_umol\/L"]), 
              this.round2(context.info["DIN_umol\/L"]), 
              this.round2(context.info["Phy_ugCh\/L"]), 
              this.round2(context.info["Zoo_mgFWm3"])
            ]
          }
        })
      };
      if (context.info["NH3_umol\/L"] || context.info["DIN_umol\/L"] || context.info["Phy_ugCh\/L"] || context.info["Zoo_mgFWm3"]) {
        return (
          <div className="chart">
            <Bar 
              data={ chartData }
              options={ chartOptions } />
          </div>
        )
      }
    }

    let displayContext = () => {
      const context = this.state.context;
      // console.log(context)
      switch (context.type) {
        case 'region':
          return (
            <div>
              <div className="context-title">
                <span>{strings.region}: </span>
                <span className="value">{context.info.Region}</span>
              </div>

              <div className="context-charts">
                { nitrogenPieChart(context) }
                { phosphorusPieChart(context) }
              </div>
            </div>
          );
        case 'subbasin':
          return (
            <div>
              <div className="context-title">
                <span>{strings.subbasin}: </span>
                <span className="value">{context.info.Subbasin}</span>
                <span> | {strings.region}: </span>
                <span className="value">{context.info.Region}</span>
              </div>

              <div className="context-charts">
                { nitrogenPieChart(context) }
                { phosphorusPieChart(context) }
              </div>
            </div>
          );
        case 'stream':
          return (
            <div>
              <div className="context-title">
                <h3>{strings.aquascapeSustainableCarryingCapacity}</h3>
                <ul>
                  <li>
                    <span>{strings.flowM3S}: </span>
                    <span className="value">{this.round2(context.info.FlowCms)}</span>
                  </li>
                  <li>
                    <span>{strings.lengthMeters}: </span>
                    <span className="value">{this.round2(context.info.Length)}</span>
                  </li>
                  <li>
                    <span>{strings.subbasin}: </span>
                    <span className="value">{context.info.Subbasin}</span>
                  </li>
                  <li>
                    <span>{strings.totalNitrogenConcentrationOrganicMineral}: </span>
                    <span className="value">{this.round2(context.info.NTotMgL_1)}</span>
                  </li>
                  <li>
                    <span>{strings.totalPhosphorusConcentrationOrganicMineral}: </span>
                    <span className="value">{this.round2(context.info.PTotMgL_1)}</span>
                  </li>
                </ul>
              </div>
            </div>
          );
        case 'bathymetry':
          return (
            <div>
              <div className="context-title">
                <span>Depth: </span>
                <span className="value">{context.info.DEPTH} m</span>
              </div>
            </div>
          );
        case 'pond':
          return (
            <div>
              <div className="context-title">
                <span>{strings.aquaculture}: </span>
                <span className="value">{context.info.Pond_Class}</span>
              </div>
              <div className="context-charts">
                <div className="feature-data">
                <table>
                  <tbody>
                    <tr>
                      <td className="property">{strings.areaM2}:</td>
                      <td className="value">{context.info["Area (m2)"]}</td>
                    </tr>
                    <tr>
                      <td className="property">{strings.volM3}:</td>
                      <td className="value">{context.info["Vol (m3)"]}</td>
                    </tr>
                    { getTotals('nStock', context) && 
                    <tr>
                      <td className="property">{strings.totalStockInd}:</td>
                      <td className="value">
                          { getTotals('nStock', context) }
                        </td>
                    </tr>
                    }
                    { getTotals('nEstProd', context) &&
                    <tr>
                      <td className="property">{strings.estimatedProductionKgPerYear}:</td>
                      <td className="value">
                        { getTotals('nEstProd', context) }
                      </td>
                    </tr>
                    }
                    <tr>
                      <td className="property">{strings.species}:</td>
                      <td className="value">{context.info.Species}</td>
                    </tr>
                    <tr>
                      <td className="property">{strings.district}:</td>
                      <td className="value">{context.info.District}</td>
                    </tr>
                    <tr>
                      <td className="property">{strings.regency}:</td>
                      <td className="value">{context.info.Regency}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
                
                { nitrogenBarChart(context) }
              </div>
            </div>
          );
        case 'fish':
          return (
            <div>
              <div className="context-title">
                <span>{strings.aquaculture}: </span>
                <span className="value">{context.info.Pond_Class}</span>
              </div>
              <div className="context-charts">
                <div className="feature-data">
                <table>
                  <tbody>
                    <tr>
                      <td className="property">{strings.areaM2}:</td>
                      <td className="value">{context.info["Area (m2)"]}</td>
                    </tr>
                    <tr>
                      <td className="property">{strings.volM3}:</td>
                      <td className="value">{context.info["Vol (m3)"]}</td>
                    </tr>
                    { getTotals('nStock', context) &&
                    <tr>
                      <td className="property">{strings.totalStockInd}:</td>
                      <td className="value">
                        { getTotals('nStock', context) }
                      </td>
                    </tr>
                    }
                    { getTotals('nEstProd', context) &&
                    <tr>
                      <td className="property">{strings.estimatedProductionKgPerYear}:</td>
                      <td className="value">
                        { getTotals('nEstProd', context) }
                      </td>
                    </tr>
                    }
                    <tr>
                      <td className="property">{strings.species}:</td>
                      <td className="value">{context.info.Species}</td>
                    </tr>
                    <tr>
                      <td className="property">{strings.district}:</td>
                      <td className="value">{context.info.District}</td>
                    </tr>
                    <tr>
                      <td className="property">{strings.regency}:</td>
                      <td className="value">{context.info.Regency}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
                
                { nitrogenBarChart(context) }
              </div>
            </div>
          );
        case 'landCover':
          return (
            <div>
              <div className="context-title">
                <span>{strings.landCover}: </span>
                <span className="value">{context.info["Land cover"]}</span>
              </div>
            </div>
          );
        case 'carryingCapacity':
          return (
            <div>
              <div className="context-title">
                <span>{strings.region}: </span>
                <span className="value">{context.info.Region}</span>
              </div>

              <div className="context-charts">
                { carryingCapacityBarChart(context) }
                { carryingCapacityNitrogenPieChart(context) }
              </div>
            </div>
          );
        default:
          return (
            null
          );
      }
    }

    let infoTotalStats = () => {
      if (this.state.activeTotalStats === 'bali') {
        return (
          <div className="info">
            <Col xs={12} sm={6} md={4} xl={3}>
              { areaHaDonut('bali') }
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              { totalNLoadsDonut('bali') }
            </Col>
            <Col xs={12} sm={6} md={4} xl={3}>
              { externalitiesBarChart('bali') }
            </Col>
          </div>
        )
      } else if (this.state.activeTotalStats === 'java') {
        return (
          <div>
            <div className="info">
              <Col xs={12} sm={6} xl={5}>
                { areaHaDonut('java') }
              </Col>
              <Col xs={12} sm={6} xl={5}>
                { totalNLoadsDonut('java') }
              </Col>
            </div>

            <div className="info">
              <Col xs={12} sm={6} lg={3}>
                { totalShrimpAquaculture('java', 'shrimpAquacultureByType') }
              </Col>
              <Col xs={12} sm={6} lg={3}>
                { totalShrimpAquaculture('java', 'shrimpAquacultureAreaHa') }
              </Col>
              <Col xs={12} sm={6} lg={3}>
                { totalShrimpAquaculture('java', 'shrimpAquacultureTotalNLoads') }
              </Col>
              <Col xs={12} sm={6} lg={3}>
                { totalShrimpAquaculture('java', 'shrimpAquacultureProduction') }
              </Col>
            </div>

            {/* <div className="info">
              <Col xs={12} sm={6} xl={5}>
                { totalShrimpAquaculture('java', 'shrimpAquacultureTotalNLoads') }
              </Col>
              <Col xs={12} sm={6} xl={5}>
                { totalShrimpAquaculture('java', 'shrimpAquacultureProduction') }
              </Col>
            </div> */}
          </div>
        )
      }
    }

    return (
      <div className="app">
        { headerNav() }
        <div className="section map">
          <div className="map-columns">
            <SidebarLocations 
              class={ this.getSidebarClass() }
              layers={ this.state.sidebarLayers }
              isLoading={ this.state.loadingLayers }
              onNavigate={ this.updateMapPosition }
              onCheckChange={ this.onLayerCheckChange } />
            <div className="map-and-context">
              <div className="map-wrapper">
                <Map 
                  toolbars={this.state.toolbars}
                  position={this.state.mapPosition}
                  layers={this.state.layers} 
                  onContextChange={this.onContextChange}
                  onClick={this.onLockContext} />
              </div>

              <div className={ this.getContextClass() }>
                { this.state.loadingLayers ? (
                  <div className="loader-padding">
                    <Loader status="Loading layers" inlineStatus={false} />
                  </div>
                ) : (
                  <div className="h-100">
                    { Object.keys(this.state.context.info).length < 1 ? (
                      <div className="d-flex align-items-center h-100">
                        <Row className="justify-content-center align-items-center">
                          <Col xs={12} className="text-center">
                            <h2 className="mt-2 mb-3 mb-lg-4">
                              <Image className="logo-small" src={aquaSmall} title="" />
                              {strings.contextDescr}
                            </h2>
                          </Col>
                          <Col xs={12} className="pt-2 d-flex justify-content-center">
                            <ul>
                              <li>{strings.selectLayersToTheRight}</li>
                              <li>{strings.hoverOverAreasOfInterestForMoreInformation}</li>
                            </ul>
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      <div>
                        { displayContext() }
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="section about">
          <div className="info-nav">
            <div 
              className={this.state.activeTotalStats==='bali'?"info-nav-item active":'info-nav-item'}
              onClick={() => {this.toggleActiveTotalStats('bali')}}>
              <h5 className="mb-0">Bali</h5>
            </div>
            <div 
              className={this.state.activeTotalStats==='java'?"info-nav-item active":'info-nav-item'}
              onClick={() => {this.toggleActiveTotalStats('java')}}>
              <h5 className="mb-0">Java</h5>
            </div>
          </div>
            
          {infoTotalStats()}
          
          <div className="footer">
            <Row className="justify-content-center justify-content-sm-around">
              <Col sm={{span: 5}} className="text-center text-sm-left">
                <p>{strings.partners}</p>
                <a href="https://www.longline.co.uk/" target="_blank" rel="noopener noreferrer">
                  <Image 
                    className="logo mr-4 mb-2" 
                    src={longlineLogo} 
                    title="Longline Environment" />
                </a>

                <a href="https://www.sustainablefish.org/" target="_blank" rel="noopener noreferrer">
                  <Image 
                    className="logo mb-2" 
                    src={sfpLogo} 
                    title="Sustainable Fisheries Partnership" />
                </a>
              </Col>
              <Col sm={{span: 5}} className="text-center text-sm-left d-flex justify-content-center justify-content-sm-end mt-4 mt-sm-0">
                <div>
                  <p>{strings.donors}</p>
                  <a href="https://www.waltonfamilyfoundation.org/" target="_blank" rel="noopener noreferrer">
                    <Image 
                      className="logo mb-2" 
                      src={wffLogo} 
                      title="Walton Family Foundation" />
                  </a>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
